/* eslint-disable */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import Link from 'react-router/lib/Link';
import get from 'lodash/get';

import { getLastMessageTime } from '../../../utils/converters/dateConverters';
import SimpleAvatar from '../../common/SimpleAvatar';
import GroupAvatar from '../../Avatar/GroupAvatar';
import Badge from '../../Badge';
import Card from '../../Card';
import Icon from '../../Icon';
import StatusIndicator from '../../common/StatusIndicator';
import { DEPENDENT_STATUSES } from '../../../constants/props';

import { COLORS } from '../../../constants/styles';
import styles from './index.styl';
import { ICON_BLOCK, CONTEXT_CHAT_ICON } from '../../../constants/chat';

@injectIntl
@CSSModules(styles, { allowMultiple: true })
export default class ListItem extends PureComponent {
  static propTypes = {
    active: PropTypes.bool,
    contextUser: PropTypes.shape({
      // eslint-disable-line react/no-unused-prop-types
      avatar: PropTypes.objectOf(PropTypes.string),
      displayableName: PropTypes.string,
      id: PropTypes.number,
      status: PropTypes.string,
    }),
    intl: PropTypes.shape({
      formatMessage: PropTypes.func,
    }),
    intro: PropTypes.string,
    lastMessageAt: PropTypes.string,
    minimized: PropTypes.bool,
    onClick: PropTypes.func,
    unreadCount: PropTypes.number,
    patientPortalContext: PropTypes.bool,
  };

  get contextUser() {
    return get(this.props, 'contextUser', {});
  }

  get contextChannel() {
    return get(this.props, 'contextChannel', {});
  }

  get lastMessageTime() {
    const {
      lastMessageAt,
      intl: { formatMessage },
    } = this.props;

    if (!lastMessageAt) return null;

    return getLastMessageTime(lastMessageAt, formatMessage);
  }

  get userData() {
    const { intro } = this.props;
    const { displayableName } = this.contextUser;

    return {
      primary: displayableName,
      complementary: this.lastMessageTime,
      intro,
    };
  }

  get channelData() {
    const { channelName } = this.contextChannel;

    return {
      primary: channelName,
      complementary: this.lastMessageTime,
    };
  }

  get rightControls() {
    const { active, unreadCount } = this.props;

    if (!active && !unreadCount) return null;

    return (
      <div className="flex items-center">
        {this.createUnreadBadge()}
      </div>
    );
  }

  get expandedItem() {
    const { id } = this.contextUser;
    const { channelId, blocked } = this.contextChannel;
    const { active } = this.props;
    const styleName = classNames('card', { 'card--active': active });

    const iconContext = this.props.contextUser ? [CONTEXT_CHAT_ICON] : null;
    const iconBlockChat = blocked ? [ICON_BLOCK] : null;

    return (
      <Card
        additionalIcons={iconContext || iconBlockChat}
        className="pa2 user-status--card"
        styleName={styleName}
        userId={id || channelId}
        text={id ? this.userData : this.channelData}
        additionalContent={{
          left: this.createAvatar({ size: 32 }),
          right: this.rightControls,
        }}
      />
    );
  }

  get minimizedItem() {
    const { patientPortalContext } = this.props;
    return patientPortalContext ? (
      <div styleName="avatar__wrapper">{this.createAvatar({ size: 36 })}</div>
    ) : (
      <div styleName="avatar__wrapper">
        {this.createAvatar({ size: 32 })}
        <div styleName="badge__wrapper">
          {this.createUnreadBadge({ colored: true })}
        </div>
      </div>
    );
  }

  get itemBody() {
    if (this.props.minimized) {
      return this.minimizedItem;
    }

    return this.expandedItem;
  }

  createAvatar(params) {
    const { size, withStatus } = params || {};
    const { active } = this.props;
    const { avatar, displayableName, status } = this.contextUser;
    const pending = status === DEPENDENT_STATUSES.PENDING;
    const unverified = status === DEPENDENT_STATUSES.UNVERIFIED;

    const {
      avatar: channelAvatar,
      channelName,
      type,
      blocked,
    } = this.contextChannel;

    const blockedStyle = blocked ? 'o-50' : '';

    const avatarComponent = (
      <SimpleAvatar
        size={size}
        bordered={active}
        waiting={pending}
        disabled={unverified}
        unverified={unverified}
        text={displayableName || channelName}
        src={get(avatar, 'thumbMin') || get(channelAvatar, 'thumbMin')}
      />
    );

    const iconComponent = (
      <GroupAvatar
        className={blockedStyle}
        {...{
          active,
          iconName: 'chat-group',
          iconSize: 20,
          width: 32,
          height: 32,
        }}
      />
    );

    if (withStatus && status) {
      return (
        <div className="relative">
          {avatarComponent}
          <StatusIndicator {...{ active, status }} />
        </div>
      );
    }

    return type === 'group' ? iconComponent : avatarComponent;
  }

  createUnreadBadge(params) {
    const { colored } = params || {};
    const { unreadCount, minimized } = this.props;

    if (!unreadCount) return null;

    return <Badge large={!minimized} {...{ colored }} text={unreadCount} />;
  }

  render() {
    const { active, minimized, onClick } = this.props;
    const { id } = this.contextUser;
    const { channelId, type } = this.contextChannel;
    // manage global navigation list styles
    const className = classNames({
      'g-navLink': !minimized,
      'g-navLink--active': !minimized && active,
    });

    // manage custom minimized navigation list styles
    const styleName = classNames({
      'item--minimized': minimized,
      'item--active': minimized && active,
    });

    return (
      <div data-id={id || channelId}>
        <Link
          {...{ className, styleName }}
          onClick={() => onClick(id || channelId, type)}
        >
          {this.itemBody}
        </Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Messages/ChatsList/ListItem.jsx